import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, Content, DashList, DataListWrap, FlexRow, Img, Td, TitleLeft, Text, DateSelectContainer, DateSelector, SubTitle, ButtonContainer, Success, Message, PopupContent, CheckRow, QuestMark } from './StudentDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import StudentThumbnail from '@components/StudentThumbnail';
import Note_Icon from "@assets/svg/notes.svg";
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import fixedNumber from '@utils/fixedNumber';
import Modal from '@components/Buttons/Modal';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import Course_Icon from "@assets/svg/subnav_course.svg";
import Sick_Icon from "@assets/svg/sick.svg";
import Course from './Course';
import Tendency from './Tendency';
import CourseModal from './CourseModal';
import Tooltip from '@components/Tooltips/Tooltip';
import { CheckboxIcon, CheckboxIconCross } from '../SchoolLeader.styled';
import { ButtonRow, ModalContent, ModalContent2 } from './CourseModal/CourseModal.styled';
import DateSelect from './DateSelect';
import Question_Icon from '@assets/svg/info-circle.svg';
import Cross_Icon from "@assets/svg/match/missing.svg"
import Cal_Icon from "@assets/svg/new_calendar.svg"
import Plane_Icon from "@assets/svg/plane.svg"
import { BtnRow, PopupWrapper, TopBar } from '../ApprovalDetails/ApprovalDetails.styled';
import toTitleCase, { normalizeName } from '@utils/textTools';
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import { GenerateExcelFile } from '../excel';
import Subject from './Subject';
import CourseSubject from './CourseSubject';

interface IProps {
  getStudents: () => void, loading: boolean,
  handleClick: (username, id, displayname, type, sick?) => void,
  secretary?: boolean,
}

export const StudentDetails = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      if (schoolViewFilter.advanced) ExcelAdvanced()
      else Excel()
    },
  }));
  const { client, settings, callNameSetting, handleNote, filterDate, schooolViewStudents, setSchoolViewStudents, setSelectedSchoolViewSearch, setSchoolLeaderView, schoolViewFilter, setSchoolViewFilter, page, setPage, systemSettings } = useStore();
  const [studentCourseData, setStudentCourseData] = useState([])
  const [sort, setSort] = useState({ type: 0, direction: false })
  const [open, setOpen] = useState(false)
  const openRef = useRef(null)
  const pageSize = 13;
  const i18n = useI18n();
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [creationgRequests, setCreatingRequests] = useState(0)
  const [requests, setRequests] = useState([{ userid: '9', success: true }, { userid: '97414', success: false }])
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())
  const holidayModalRef = useRef(null);
  const [text, setText] = useState('')
  const [holidayModal, setHolidayModal] = useState(false)
  const [selectedHolidayStudent, setSelectedHolidayStudent] = useState(null)
  const [courseList, setCourseList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const [loading, setLoading] = useState(false)

  let s = systemSettings?.find(s => s.APP_Setting_ID === 74)
  let s2 = systemSettings?.find(s => s.APP_Setting_ID === 77)
  let studentCallName = systemSettings?.find(s => s.APP_Setting_ID === 48).value

  useEffect(() => {
    getCoursesDB()
    getSubjectsDB()
  }, [])

  useEffect(() => {
    if(schoolViewFilter.advanced)
    {
      setLoading(true)
      Promise.all([getCourseData(),
      getStudentsAdvanced()]).then(() => setLoading(false)
      )
      
    }
    else
    {
      setLoading(true)
      Promise.all([getCourseData(),
      getStudents()]).then(() => setLoading(false)
      )
    }
    
    
  }, [filterDate, schoolViewFilter.advanced])

  useEffect(() => {
    getCourseData()
  }, [schoolViewFilter.courses1])

  const getStudents = async () => {
    await props.getStudents()
  }

  const getCourseData = async () => {
    let courses = schoolViewFilter.courses1
    let subjects = schoolViewFilter.subjects1
    let data = await db.GetStudentAbsenceOnCourseAndSubject(filterDate.from, filterDate.to, courses.map(c => { return { course_id: c } }), subjects.map(c => { return { subject_name: c.split(',')[1] } }))
    setStudentCourseData(data)    
  }

  const getFilteredStudents = () => {
    let studentsTemp = JSON.parse(JSON.stringify(schooolViewStudents))
    studentsTemp = studentsTemp
      ?.filter(s => (s.active === true && schoolViewFilter.active === true) || (s.active === false && schoolViewFilter.inactive === true))
      .filter(s => {
        let p = (settings.SHOWPRESENCE ? (100 - schoolViewFilter.percentage1) : schoolViewFilter.percentage1)
        p = p == 100 ? 0 : p;
        return s.percentage >= p
      })
      .filter(s => s.displayname?.toLowerCase().includes(schoolViewFilter.search1?.toLowerCase()))
      .filter(s => {
        if (schoolViewFilter.courses1.length === 0) {
          return true
        }
        else {
          let courses = s.courselist.split(',')
          if (schoolViewFilter.courses1.some(c => courses.includes(c)))
            return true
          else
            return false
        }
      }).filter(s => {
        if (schoolViewFilter.subjects1.length > 0) {
          if (studentCourseData.length > 0 && studentCourseData.findIndex(c => c.student_id === s.student_id) > -1)
            return true
          else return false
        }
        else
          return true
      })

    return studentsTemp
  }

  const getAdvanceFilteredStudents = () => {
    let studentsTemp = JSON.parse(JSON.stringify(advancedList))
    studentsTemp = studentsTemp
      .filter(s => {
        let p = (settings.SHOWPRESENCE ? (100 - schoolViewFilter.percentage_best1) : schoolViewFilter.percentage_best1)
        p = p == 100 ? 0 : p;
        if(settings.SHOWPRESENCE && p === 100) p = 0;
        else if(!settings.SHOWPRESENCE && p === 0) p = 100;

        return settings.SHOWPRESENCE ? s.bestcase_percentage >= p : s.bestcase_percentage <= p
      })
      .filter(s => {
        let p = (settings.SHOWPRESENCE ? (100 - schoolViewFilter.percentage1) : schoolViewFilter.percentage1)        
        p = p == 100 ? 0 : p;
        return s.current_percentage >= p
      })
      .filter(s => s.student_name?.toLowerCase().includes(schoolViewFilter.search1?.toLowerCase()))
      .filter(s => {
        if (schoolViewFilter.courses1.length === 0) {
          return true
        }
        else {
          let courses = s.course_id
          if (schoolViewFilter.courses1.some(c => courses.includes(c)))
            return true
          else
            return false
        }
      }).filter(s => {
        if (schoolViewFilter.subjects1.length > 0) {
          if (schoolViewFilter.subjects1.findIndex(c => {
            let sub = c.split(",")
            return (s.course_id === sub[0] && s.course_description === sub[1])
          }) > -1)
            return true
          else return false
        }
        else
          return true
      })
    return studentsTemp
  }

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  function getSortedStudents() {
    let studentsTemp = getFilteredStudents()
    studentsTemp = studentsTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.percentage > b.percentage) return 1 * dir
          else if (a.percentage < b.percentage) return -1 * dir
          else return 0
          break;
        case 2:
          if (a.active === b.active) return 0
          else if (a.active) return 1 * dir
          else if (b.active) return -1 * dir
          else return 0
          break;
      }
    })
    return studentsTemp
  }
  
  function getadvanceSortedStudents() {
    let studentsTemp = getAdvanceFilteredStudents()
    studentsTemp = studentsTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.student_name > b.student_name) return 1 * dir
          else if (a.student_name < b.student_name) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.course_displayname > b.course_displayname) return 1 * dir
          else if (a.course_displayname < b.course_displayname) return -1 * dir
          else return 0
          break;
        case 2:
          if (a.course_description > b.course_description) return 1 * dir
          else if (a.course_description < b.course_description) return -1 * dir
          else return 0
          break;
        case 3:
          if (a.current_percentage > b.current_percentage) return 1 * dir
          else if (a.current_percentage < b.current_percentage) return -1 * dir
          else return 0
          break;
        case 4:
          if (a.bestcase_percentage > b.bestcase_percentage) return 1 * dir
          else if (a.bestcase_percentage < b.bestcase_percentage) return -1 * dir
          else return 0
          break;
        case 5:
          if (a.worstcase_percentage > b.worstcase_percentage) return 1 * dir
          else if (a.worstcase_percentage < b.worstcase_percentage) return -1 * dir
          else return 0
          break;
        case 6:
          if (a.lastlesson_date > b.lastlesson_date) return 1 * dir
          else if (a.lastlesson_date < b.lastlesson_date) return -1 * dir
          else return 0
          break;
        case 7:
          if (a.current_duration > b.current_duration) return 1 * dir
          else if (a.current_duration < b.current_duration) return -1 * dir
          else return 0
          break;
        case 8:
          if (a.remaining_duration > b.remaining_duration) return 1 * dir
          else if (a.remaining_duration < b.remaining_duration) return -1 * dir
          else return 0
          break;
      }
    })
    return studentsTemp
  }

  const handleOpen = (studentId) => {
    setSelectedStudent(studentId)
    setOpen(true)
  }

  const getHolidayPopupContent = () => {
    if (creationgRequests === 0) {
      return <>
        <PopupContent>
          <Text>{i18n.t('schoolview-holiday-popup-text')}</Text>
          <DateSelectContainer span={true}>

            <SubTitle>{i18n.t('course-startdate')}</SubTitle>
            <DateSelect minDate={true} type={1} value={fromDate} setDate={handleDate}>
              <DateSelector><span>{moment(fromDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
            </DateSelect>

            <SubTitle>{i18n.t('course-enddate')}</SubTitle>
            <DateSelect type={2} minDate={true} value={toDate} setDate={handleDate}>
              <DateSelector><span>{moment(toDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
            </DateSelect>
          </DateSelectContainer>

          <SubTitle>{i18n.t('schoolview-holiday-popup-message')}</SubTitle>
          <textarea value={text} onChange={handleTextInput} placeholder={i18n.t('schoolview-holiday-popup-message-placeholder')} />
        </PopupContent>
        <BtnRow>
          <button onClick={() => CreateRequest()}>{i18n.t("schoolview-holiday-popup-create")}</button>
          <button onClick={() => handleClose()}>{i18n.t("note-cancel")}</button>
        </BtnRow>
      </>
    }
    else if (creationgRequests === 1) {
      return <>
      <PopupContent>
        <Text>{i18n.t('schoolview-holiday-popup-creating-text')}</Text>
      </PopupContent>

      </>
    }
    else {
      let r = []
      for (let i = 0; i < requests.length; i++) {
        const request = requests[i];
        let student = schooolViewStudents.find(s => s.student_id === request.userid)
        if (student) r.push(<Text key={"success_" + i}>{request.success ? i18n.t('schoolview-holiday-popup-requests-text') : i18n.t('schoolview-holiday-popup-fail-text')}</Text>)
      }

      return <>
      <PopupContent>
        {r}
      </PopupContent>
        <ButtonContainer>
          <button onClick={() => handleClose()}>{i18n.t('close')}</button>
        </ButtonContainer>
      </>
    }
  }

  const handleClose = () => {
    holidayModalRef.current.handleClose()
    setText('')
    setFromDate(new Date())
    setToDate(new Date())
    setTimeout(() => {
      setCreatingRequests(0)
    }, 1000)
  }

  const handleTextInput = (e) => {
    setText(e.target.value)
  }

  const handleDate = (type, date) => {
    if (type === 1) {
      let t = moment(toDate)
      let d = moment(date)
      setFromDate(date)
      if (t.isBefore(d, 'date')) {
        d = moment(d)
        d.add(1, 'day')
        setToDate(d.toDate())
      }
    }
    else {
      let t = moment(fromDate)
      let d = moment(date)
      setToDate(date)
      if (t.isAfter(d, 'date')) {
        let today = moment()
        d = moment(d)
        if (d.isAfter(today, 'date'))
          d.add(-1, 'day')
        setFromDate(d.toDate())
      }
    }
  }

  const CreateRequest = async () => {
    let start: any = fromDate;
    let end: any = toDate;
    start = moment(fromDate).format('YYYY-MM-DD')
    end = moment(toDate).format('YYYY-MM-DD')
    let success = []
    setCreatingRequests(1)
    let request = await db.CreateAbsenceRequest(selectedHolidayStudent.student_id, start, end, null, text, 1, client.UserName)
    if(request && request.length > 0 && request[0].result > 1)
    {
      success.push({ userid: selectedHolidayStudent.student_id, success: (request && request.length > 0 && request[0].result > 1) })
      await db.ApproveDenyRequest(request[0].result, client.UserName, true, "")
    }    
    setRequests(success)
    setCreatingRequests(2)
    getStudents()
  }

  const handleHolidayOpen = (student) => {
    setHolidayModal(true)
    setSelectedHolidayStudent(student)
  }

  const getTextCount = () => {
    let count;
    let totalCount;
    if (schoolViewFilter.advanced){
      count = getAdvanceFilteredStudents()?.length
      totalCount = advancedList?.length
    } else {
      count = getFilteredStudents()?.length
      totalCount = schooolViewStudents?.length
    }
    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }
  }

  const getCoursesDB = async () => {
    let courses = await db.GetCourseList(filterDate.from, filterDate.to);
    let temp = courses.map(c => { return { course_id: c.course_sis_id, course_name: c.course_description } });
    setCourseList(temp);
  }

  const getSubjectsDB = async () => {
    let subjects = await db.GetSubjectList(filterDate.from, filterDate.to);
    let temp = subjects.map(c => { return { course_id: c.course_sis_id, subject_description: c.subject_description } });
    setSubjectList(temp);
  }
  const Excel = () => {
    let data = (getSortedStudents() ?? []).map(r => {
      let object = {}
      object[i18n.t("header-name")] = r.displayname;
      object[i18n.t(settings.SHOWPRESENCE ? "header-total-attendance" : "header-total-absence")] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(r.percentage));
      object[i18n.t("active")] = r.active;
      if (schoolViewFilter.courses1.length > 0 && schoolViewFilter.subjects1.length === 0) {
        for (let index = 0; index < schoolViewFilter.courses1.length; index++) {
          const course_id = schoolViewFilter.courses1[index];
          let course = courseList.find(c => c.course_id === course_id);
          if (course) {
            let student = studentCourseData.filter(s => s.student_id === r.student_id)
            let courseData = student.find(s => s.course_id === course_id);
            if (courseData) {
              object[course.course_name] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(courseData.percentage));
            } 
          }
        }
      }
      else if (schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length === 0) {
        for (let index = 0; index < schoolViewFilter.subjects1.length; index++) {
          const subject_id = schoolViewFilter.subjects1[index];
          let subject = subjectList.find(c => c.subject_description === subject_id.split(',')[1]);
          if (subject) {
            let student = studentCourseData.filter(s => s.student_id === r.student_id)
            let courseData = student.find(s => s.subject_name === subject.subject_description);
            if (courseData) {
              object[subject.subject_description] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(courseData.percentage));
            }
          }
        }
      }
      else if (schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length > 0) {
        for (let index = 0; index < schoolViewFilter.subjects1.length; index++) {
          const subject_id = schoolViewFilter.subjects1[index];
          let course_id = subject_id.split(',')[0];
          let course = courseList.find(c => c.course_id === course_id);
          let subject = subjectList.find(c => c.subject_description === subject_id.split(',')[1]);
          if (subject) {
            let student = studentCourseData.filter(s => s.student_id === r.student_id)
            let courseData = student.find(s => s.subject_name === subject.subject_description && s.course_id === course_id);
            if (courseData) {
              object[`${course.course_name} - ${subject.subject_description}`] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(courseData.percentage));
            }
          }
        }
      }
      return object;
    });

    let headers = [
      i18n.t("header-name"),
      i18n.t(settings.SHOWPRESENCE ? "header-total-attendance" : "header-total-absence"),
      i18n.t("active"),
    ];

    if (schoolViewFilter.courses1.length > 0 && schoolViewFilter.subjects1.length === 0) {
      for (let index = 0; index < schoolViewFilter.courses1.length; index++) {
        const course_id = schoolViewFilter.courses1[index];
        let course = courseList.find(c => c.course_id === course_id);
        if (course) {
          headers.push(course.course_name);
        }
      }
    }
    else if (schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length === 0) {
      for (let index = 0; index < schoolViewFilter.subjects1.length; index++) {
        const subject_id = schoolViewFilter.subjects1[index];
        let subject = subjectList.find(c => c.subject_description === subject_id.split(',')[1]);
        if (subject) {
          headers.push(subject.subject_description);
        }
      }
    } 
    else if (schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length > 0) {
      for (let index = 0; index < schoolViewFilter.subjects1.length; index++) {
        const subject_id = schoolViewFilter.subjects1[index];
        let course_id = subject_id.split(',')[0];
        let course = courseList.find(c => c.course_id === course_id);
        let subject = subjectList.find(c => c.subject_description === subject_id.split(',')[1]);
        if (course && subject) {
          headers.push(`${course.course_name} - ${subject.subject_description}`);
        }
      }
    }


    GenerateExcelFile(i18n.t(callNameSetting + "-s") + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t(callNameSetting + "-s") + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }

  const ExcelAdvanced = () => {
    let advancedHeader = [
      i18n.t("header-name"),
      i18n.t("course"),
      i18n.t("subject"),
      i18n.t("current-procen"),
      i18n.t("worst-procen"),
      i18n.t("best-procen"),
      i18n.t("last-date"),
      i18n.t("current-time"),
      i18n.t("time-left")
    ]

    let advancedData = (getadvanceSortedStudents() ?? []).map(r => {
      let object = {}
      object[i18n.t("header-name")] = r.student_name;
      object[i18n.t("course")] = r.course_displayname;
      object[i18n.t("subject")] = r.course_description;
      object[i18n.t("current-procen")] = r.current_percentage;
      object[i18n.t("worst-procen")] = r.worstcase_percentage;
      object[i18n.t("best-procen")] = r.bestcase_percentage;
      object[i18n.t("last-date")] = moment(r.lastlesson_date).format("DD-MM-YYYY");
      object[i18n.t("current-time")] = ConvertTime(r.current_duration);
      object[i18n.t("time-left")] = ConvertTime(r.remaining_duration);
      return object;
    })
    GenerateExcelFile(i18n.t(callNameSetting + "-s") + "_" + moment().format('DD-MM-YYYY-HHmm'), advancedHeader, advancedData, i18n.t(callNameSetting + "-s") + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }


  const [advancedList, setAdvancedList] = useState([])

  const getStudentsAdvanced = async () => {
    let students = await db.GetStudentAbsenceWithPredictions(filterDate.from);    
    setAdvancedList(students);
  }

  const ConvertTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);

    return (hours + i18n.t("hour") + " " + minutes + i18n.t("minute"))
  }

  return (<>
    {holidayModal && <Modal ref={holidayModalRef} clickOutside={false} onClose={setHolidayModal} backColor={"rgba(0, 0, 0, .4)"}>
      <PopupWrapper>
        <TopBar>
          <span>{i18n.t('schoolview-holiday-popup-header')} ({selectedHolidayStudent.displayname})</span>
          {creationgRequests === 0 ? <div onClick={() => handleClose()}><Cross_Icon /></div> : <></>}
        </TopBar>

        {getHolidayPopupContent()}
      </PopupWrapper>
    </Modal>}

    {open ? <Modal ref={openRef} onClose={setOpen} backColor={"rgba(0,0,0,0.25)"} >
      <ModalContent>
        <CourseModal selectedStudent={selectedStudent} />
        <ButtonRow>
          <button onClick={() => openRef.current?.handleClose()}>{i18n.t("close")}</button>
        </ButtonRow>
      </ModalContent>
    </Modal> : null}

    <Content>
      <TitleLeft>
        <span>{toTitleCase(i18n.t(callNameSetting + "-s"))}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>

      {props.loading || loading? <RainbowLoader /> : (schoolViewFilter.advanced && getadvanceSortedStudents().length > 0) ? <><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"} ></td>
              <Td className={"width50"} onClick={() => handleSort(0)}><div>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></div></Td>
              <Td className={"width20"} onClick={() => handleSort(1)}><div>{i18n.t("course")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></div></Td>
              <Td className={"width20"} onClick={() => handleSort(2)}><div>{i18n.t("subject")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(3)}><div><Tooltip content={i18n.t("current-procen-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("current-procen")} <SortArrow sortActive={sort.type === 3} asc={sort.type === 3 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(5)}><div><Tooltip content={i18n.t("worst-procen-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("worst-procen")} <SortArrow sortActive={sort.type === 5} asc={sort.type === 5 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(4)}><div><Tooltip content={i18n.t("best-procen-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("best-procen")} <SortArrow sortActive={sort.type === 4} asc={sort.type === 4 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(6)}><div><Tooltip content={i18n.t("last-date-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("last-date")} <SortArrow sortActive={sort.type === 6} asc={sort.type === 6 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(7)}><div><Tooltip content={i18n.t("current-time-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("current-time")} <SortArrow sortActive={sort.type === 7} asc={sort.type === 7 && sort.direction === false} /></div></Td>
              <Td className={""} onClick={() => handleSort(8)}><div><Tooltip content={i18n.t("time-left-tooltip")}><QuestMark><Question_Icon /></QuestMark></Tooltip>{i18n.t("time-left")} <SortArrow sortActive={sort.type === 8} asc={sort.type === 8 && sort.direction === false} /></div></Td>
            </tr>
            {getadvanceSortedStudents().length > 0 ? getadvanceSortedStudents().slice((page * pageSize - pageSize), pageSize * page).map((r, index) => {
              return <tr key={"student_" + index}>
                <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={r?.student_name} src={r.username} /></Img></td>
                <td className={"clickable width50"} onClick={() => props.handleClick(r.username, r.student_id, r.student_name, "STUDENT")}><Tooltip placement='top-start' content={i18n.t("show-details-" + studentCallName)}>{r.student_name}</Tooltip></td>
                <td className={"width20"}>{r.course_displayname.length < 18 ?r.course_displayname:<Tooltip content={r.course_displayname}>{normalizeName(r.course_displayname, 18)}</Tooltip>}</td>
                <td className={"width20"}>{r.course_description.length < 18 ?r.course_description:<Tooltip content={r.course_description}>{normalizeName(r.course_description, 18)}</Tooltip>}</td>
                <td className={"right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, r.current_percentage).toFixed(1)} %</td>
                <td className={"right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, r.worstcase_percentage).toFixed(1)} %</td>
                <td className={"right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, r.bestcase_percentage).toFixed(1)} %</td>
                <td className={"right"}>{moment(r.lastlesson_date).format("DD-MM-YYYY")}</td>
                <td className={"right"}>{ConvertTime(r.current_duration)}</td>
                <td className={"right"}>{ConvertTime(r.remaining_duration)}</td>
              </tr>
            }) : null}
          </tbody>
        </DashList>
        </DataListWrap>

        <Pagination pageSize={pageSize} count={getadvanceSortedStudents()?.length} currentPage={page} maxPage={Math.ceil(getadvanceSortedStudents()?.length / pageSize)} setPage={setPage} /></> 
        :
        !schoolViewFilter.advanced && getSortedStudents()?.length > 0 ?<><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"} ></td>
              <Td className={"width50"} onClick={() => handleSort(0)}><div>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /> </div></Td>
              <Td className={"right"} onClick={() => handleSort(1)}><div>{i18n.t(settings.SHOWPRESENCE ? "header-total-attendance" : "header-total-absence")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /> </div></Td>
              {schoolViewFilter.courses1.length > 0 && schoolViewFilter.subjects1.length === 0 ? <Td className={"right"}><div>{i18n.t(settings.SHOWPRESENCE ? "header-course-attendance2" : "header-course-absence2")}  </div></Td> : null}
              {schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length === 0 ? <Td className={"right"}><div>{i18n.t(settings.SHOWPRESENCE ? "header-subject-attendance" : "header-subject-absence")}  </div></Td> : null}
              {schoolViewFilter.subjects1.length > 0 && schoolViewFilter.courses1.length > 0 ? <Td className={"right"}><div>{i18n.t(settings.SHOWPRESENCE ? "header-coursesubject-attendance" : "header-coursesubject-absence")}  </div></Td> : null}
              <Td className={"center"} onClick={() => handleSort(2)}><div>{i18n.t("header-active")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /> </div></Td>
              <td></td>
            </tr>
            {getSortedStudents().length > 0 ? getSortedStudents().slice((page * pageSize - pageSize), pageSize * page).map((r, index) => {
              let student = studentCourseData.filter(s => s.student_id === r.student_id)
              return <tr key={"student_" + index}>
                <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={r?.displayname} src={r.username} /></Img></td>
                <td className={"clickable width50"} onClick={() => props.handleClick(r.username, r.student_id, r.displayname, "STUDENT")}><Tooltip placement='top-start' content={i18n.t("show-details-" + studentCallName)}>{r.displayname}</Tooltip></td>
                <td><FlexRow className='p-right'>{fixedNumber(ShowabsenceOrAttendance(settings.SHOWPRESENCE, r.percentage))}% <Tendency tendencyUp={false} studentId={r.student_id} /></FlexRow></td>
                {<Course username={r.username} displayname={r.displayname} studentId={r.student_id} courselist={courseList} student={student.length === 0 ? null : student} courseCount={schoolViewFilter.courses1.length} subjectCount={schoolViewFilter.subjects1.length} />}
                {<Subject username={r.username} displayname={r.displayname} studentId={r.student_id} subjectList={subjectList} student={student.length === 0 ? null : student} subjectCount={schoolViewFilter.subjects1.length} courseCount={schoolViewFilter.courses1.length} />}
                {<CourseSubject username={r.username} displayname={r.displayname} studentId={r.student_id} courselist={courseList} student={student.length === 0 ? null : student} subjectCount={schoolViewFilter.subjects1.length} courseCount={schoolViewFilter.courses1.length} />}
                <td className={"center"} ><CheckRow>{r.active ? <><CheckboxIcon /> {i18n.t("active")}</> : <><CheckboxIconCross /> {i18n.t("inactive")}</>}</CheckRow></td>
                <td>
                  <ActionBar>
                    <Tooltip content={i18n.t("course-info")}><Course_Icon onClick={() => handleOpen(r)} /></Tooltip>
                    <Tooltip content={i18n.t("tooltip-registration-method-sick")}><Sick_Icon onClick={() => props.handleClick(r.username, r.student_id, r.displayname, "STUDENT", true)} /></Tooltip>
                    {((props.secretary && s2.value.toLowerCase() === "true") || (!props.secretary && s.value.toLowerCase() === "true")) ? <Tooltip content={i18n.t("schoolview-holiday-popup-header")}><Plane_Icon onClick={() => handleHolidayOpen(r)} /></Tooltip> : null}
                    <Tooltip content={i18n.t("notes")}><Note_Icon onClick={() => handleNote(r.student_id, r.displayname)} /></Tooltip>
                  </ActionBar>
                </td>
              </tr>
            }) : null}
          </tbody>
        </DashList>
        </DataListWrap>

        <Pagination pageSize={pageSize} count={getSortedStudents()?.length} currentPage={page} maxPage={Math.ceil(getSortedStudents()?.length / pageSize)} setPage={setPage} /></> 
        :
        <EmptyBox Graphic='documents' marvin={true} text={i18n.t("no-filter-data")} />
      }
    </Content>
  </>);
});

export default StudentDetails;
